/**
 * Created by jiachenpan on 16/11/18.
 */

export function isvalidUsername(str) {
    var reg = /^[a-zA-Z]{1}([a-zA-Z0-9]|[_]){0,19}$/;
    return reg.test(str);
  }
  
  /* 合法uri*/
  export function validateURL(textval) {
    const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
    return urlregex.test(textval);
  }
  
  /* 小写字母*/
  export function validateLowerCase(str) {
    const reg = /^[a-z]+$/;
    return reg.test(str);
  }
  
  /* 大写字母*/
  export function validateUpperCase(str) {
    const reg = /^[A-Z]+$/;
    return reg.test(str);
  }
  
  /* 大小写字母*/
  export function validateAlphabets(str) {
    const reg = /^[A-Za-z]+$/;
    return reg.test(str);
  }
  
  /**
   * validate email
   * @param email
   * @returns {boolean}
   */
  export function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  /**
   * validateQQ
   * @param {String} qq
   */
  export function validateQQ(qq) {
    const re = /^[1-9]\d{4,9}$/;
    return re.test(qq);
  }
  /* 手机号 */
  export function isvalidPhone(str) {
    const reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
    return reg.test(str);
  }
  /* 验证座机 */
  /* 匹配格式：
  11位手机号码
  3-4位区号，7-8位直播号码，1－4位分机号 */
  export function isvalidTelephone(str) {
    const reg = /^1[3|4|5|7|8|9][0-9]{9}$/;
    const reg_tele = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
    return reg.test(str) || reg_tele.test(str);
  }
  
  export function isvalidEnglishAndNumber(str) {
    const reg = /^[0-9a-zA-Z_]{1,}$/;
    return reg.test(str);
  }
  
  export function isvalidEnglishAndNumberAndChinese(str) {
    const reg = /^[a-zA-Z0-9\u4e00-\u9fa5]*$/;
    return reg.test(str);
  }
  
  export function isvalidFloat(str) {
    const reg = /^\-?[0-9]+\.[0-9]+$/;
    return reg.test(str);
  }
  
  export function isvalidIntegar(str) {
    const reg = /^[0-9]+$/;
    return reg.test(str);
  }
  // 非负浮点数验证
  export function isvalidPositive(str) {
    const reg = /^\d+(\.\d+)?$/;
    return reg.test(str);
  }
  // 可以以字母开头,只能包含字母和数字
  export function isvalidSheetCode(str) {
    const reg = /^[a-zA-z]{0,4}[0-9]{15,32}$/;
    return reg.test(str);
  }
  // 必须包含数字字母验证
  export function isvalidPassWordRule(str) {
    const reg = /[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/;
    return reg.test(str);
  }
  // 必须是数字并且>=0
  export function isvalidNumber(str) {
    const reg = /^[0-9]*.{1}[0-9]*$/;
    if (reg.test(str)) {
      if (Number(str) >= 0) {
        return true;
      }else {
        return false;
      }
    }else {
      //reg.test(str);
      return false;
    }
  }
  // 订单数量
  export function isvalidOrderQuantity(str) {
    const reg = /^[0-9\.\-\+\*\/\(\)]{0,100}$/;
    return reg.test(str);
  }
  
  /**
   * 正整数
   */
  export function isValidNum(num) {
    const reg = /(^[1-9]\d*$)/;
    return reg.test(num);
  }
  


// WEBPACK FOOTER //
// ./src/utils/validate.js